import _ from 'lodash';
import { flipObject } from '@/shared/lib';
import { AI_EVENTS_STATUS } from '@/shared/config';

export const AI_EVENT_TYPE_CONVERT_DOWN = {
  AFIB: 'AFib',
  TACHY: 'Tachy',
  BRADY: 'Brady',
  PAUSE: 'Pause',
  MAX_HR: 'Max HR',
  MIN_HR: 'Min HR',
  SINGLE_VE: 'Single VE',
  SINGLE_SVE: 'Single SVE',
  VE_TRIGEMINAL: 'VE Trigeminy',
  VE_COUPLET: 'VE Couplet',
  VE_BIGEMINY: 'VE Bigeminy',
  VE_QUADRIGEMINY: 'VE Quadrigeminy',
  VE_RUN: 'VE Run',
  SVE_RUN: 'SVE Run',
  SVE_COUPLET: 'SVE Couplet',
  SVE_BIGEMINY: 'SVE Bigeminy',
  SVE_TRIGEMINAL: 'SVE Trigeminy',
  SVE_QUADRIGEMINY: 'SVE Quadrigeminy',
  SVT: 'SVT',
  VT: 'VT',
  AVB3: '3rd Deg HB',
  AVB2: '2nd Deg HB',
  // AVB1: '1st Deg HB',
  ARTIFACT: 'Artifact',
  Deleted: 'Deleted',
  OTHERS: 'Other events',
  BASELINE: 'Baseline',
};

export const AI_EVENT_TYPE_CONVERT_UP = flipObject(AI_EVENT_TYPE_CONVERT_DOWN);

const couldNotRemoveAllStripType = [
  AI_EVENT_TYPE_CONVERT_DOWN.MAX_HR,
  AI_EVENT_TYPE_CONVERT_DOWN.MIN_HR,
  'MAX_HR',
  'MIN_HR',
];

/**
 * Decides whether a strip may be removed from an event without leaving it stripless. Returns false only for the event types that must keep at least one strip and only while a single non-removed strip or capture is left, allowing removal in every other case.
 *
 * @param data - Event carrying its type together with its strips and captures.
 * @returns True when the strip may be removed.
 */
export const checkCouldRemoveStrip = (data: any) => {
  const { type, strips, captures } = data || {};
  if (couldNotRemoveAllStripType.includes(type)) {
    const filterStrips = _.filter(
      [...(strips || []), ...(captures || [])],
      (strip) => strip.status !== AI_EVENTS_STATUS.REMOVED,
    );
    if (filterStrips.length === 1) {
      return false;
    }
    return true;
  }
  return true;
};
